import {
  defineNuxtRouteMiddleware,
  useNuxtApp,
  createError,
  type RouteMiddleware
} from 'nuxt/app'
import { flatten } from 'lodash-es'
import { allowsTo } from '~/lib/allowsTo'

export const handleRouteAccess: RouteMiddleware = (to) => {
  const nuxtApp = useNuxtApp()
  const { $store, $envConfig } = nuxtApp

  let routeConfig: any[] = []
  if (!$envConfig || !$envConfig.navigation) {
    return
  }
  Object.keys($envConfig.navigation).forEach((n) => {
    routeConfig = [
      ...routeConfig,
      ...flatten($envConfig.navigation[n]).filter((o: any) => {
        return (
          to.name &&
          (o.route === to.name.toString().replace('-id', '') ||
            o.route?.name === to.name.toString().replace('-id', ''))
        )
      })
    ]
  })

  // didn't found a config for current route
  if (routeConfig.length === 0) {
    return
  }

  // check if User is allowed
  const userCapabilities = $store.getters['user/capabilities']
  const item = routeConfig[0]
  if (!allowsTo(item, userCapabilities)) {
    throw createError({ statusCode: 403 })
  }
}

export default defineNuxtRouteMiddleware(handleRouteAccess)
